import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import AssetPurchaseOrder from '@/types/table/assetPurchaseOrder';
import { AssetPurchaseOrderDetailsData } from '@/api/generated/assetPurchaseOrderDetailsController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface AssetPurchaseOrderData extends AssetPurchaseOrder {
  assetPurchaseOrderDetailsList?: AssetPurchaseOrderDetailsData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class AssetPurchaseOrderController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<AssetPurchaseOrderData>>(
      API_CONTEXT + '/asset/assetPurchaseOrder/list',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<AssetPurchaseOrderData>(
      API_CONTEXT + '/asset/assetPurchaseOrder/view',
      params,
      httpOptions,
    );
  }
  static viewFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<AssetPurchaseOrderData>(
      API_CONTEXT + '/asset/assetPurchaseOrder/viewFlow',
      params,
      httpOptions,
    );
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/asset/assetPurchaseOrder/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/asset/assetPurchaseOrder/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/asset/assetPurchaseOrder/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/assetPurchaseOrder/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/assetPurchaseOrder/update', params, httpOptions);
  }
  static assetInStore(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/assetPurchaseOrder/assetInStore', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/assetPurchaseOrder/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/assetPurchaseOrder/deleteBatch', params, httpOptions);
  }
  static startOnlyAssetPurchaseOrderFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/asset/assetPurchaseOrder/startOnly/AssetPurchaseOrderFlow',
      params,
      httpOptions,
    );
  }
  static startWithBusinessKeyAssetPurchaseOrderFlow(
    params: ANY_OBJECT,
    httpOptions?: RequestOption,
  ) {
    return super.post(
      API_CONTEXT + '/asset/assetPurchaseOrder/startWithBusinessKey/AssetPurchaseOrderFlow',
      params,
      httpOptions,
    );
  }
  static startAndTakeUserTaskAssetPurchaseOrderFlow(
    params: ANY_OBJECT,
    httpOptions?: RequestOption,
  ) {
    return super.post(
      API_CONTEXT + '/asset/assetPurchaseOrder/startAndTakeUserTask/AssetPurchaseOrderFlow',
      params,
      httpOptions,
    );
  }
  static startAndSaveDraftAssetPurchaseOrderFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/asset/assetPurchaseOrder/startAndSaveDraft/AssetPurchaseOrderFlow',
      params,
      httpOptions,
    );
  }
  static submitUserTaskAssetPurchaseOrderFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/asset/assetPurchaseOrder/submitUserTask/AssetPurchaseOrderFlow',
      params,
      httpOptions,
    );
  }
  static viewTaskBusinessDataAssetPurchaseOrderFlow(
    params: ANY_OBJECT,
    httpOptions?: RequestOption,
  ) {
    return super.get(
      API_CONTEXT + '/asset/assetPurchaseOrder/viewTaskBusinessData/AssetPurchaseOrderFlow',
      params,
      httpOptions,
    );
  }
  static viewHistoricTaskBusinessDataAssetPurchaseOrderFlow(
    params: ANY_OBJECT,
    httpOptions?: RequestOption,
  ) {
    return super.get(
      API_CONTEXT + '/asset/assetPurchaseOrder/viewHistoricTaskBusinessData/AssetPurchaseOrderFlow',
      params,
      httpOptions,
    );
  }
  static listWorkOrderAssetPurchaseOrderFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/asset/assetPurchaseOrder/listWorkOrder/AssetPurchaseOrderFlow',
      params,
      httpOptions,
    );
  }
}
